import React from "react";
import { CreateProjectsSc } from "./index.sc";
import { useForm } from "react-hook-form";
import { useAuthContext } from "../../hooks";
import { createProjects } from "../../api/project/createProjects";
import Navbar from "../../Components/Navbar";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
function Index() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  const auth = useAuthContext();
  console.log("I am here", auth?.userInfo?.orgs_user_id[0]);
  const handleCreate = async (e: any) => {
    console.debug("data > ", e);
    await createProjects(auth?.userInfo?.orgs[0]?.id, {
      ...e,
      created_by: auth?.userInfo?.orgs_user_id[0],
    })
      .then((e) => {
        console.log(e);
      })
      .catch((err) => {
        console.log("====================================");
        console.log(err);
        console.log("====================================");
      });
  };

  const onSubmit = async (e: any) => {
    console.log(e);
    reset();
    await handleCreate(e);
    navigate(`..`);
  };
  return (
    <CreateProjectsSc>
      <div className="form-container">
        <header></header>
        <form className="create-user-form" onSubmit={handleSubmit(onSubmit)}>
          <label htmlFor="project_name" className="project-name-label">
            Project Name :
          </label>
          <input
            type="text"
            id="project_name"
            placeholder="Enter project name"
            className="form-input"
            {...register("name", {
              required: { value: true, message: "This is required" },
            })}
          />

          <label>Project Description:</label>
          <textarea
            {...register("description", {
              required: { value: true, message: "This is required" },
            })}
          ></textarea>
          <div className="btn-container">
            <Button type="submit">Submit</Button>
          </div>
        </form>
      </div>
    </CreateProjectsSc>
  );
}

export default Index;
